module.exports = __webpack_public_path__ + "media/pdf/sac_logo_cmyk_de_pos.opti-5277651b.jpg";